export default __webpack_public_path__ + "static/media/logo-us-bestbuy.2a3f26f5.svg";